import { render } from "./NewShift.vue?vue&type=template&id=55c10216"
import script from "./NewShift.vue?vue&type=script&lang=js"
export * from "./NewShift.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__